import Analytics from '../../../frontend/js/analytics';

class Profile {
    constructor() {
        const isProfilePage = document.querySelector('.profile-forms');

        if (isProfilePage) {
            this.addEventListeners();
            this.initializeChips();
            this.setDefaultView();
        }
    }

    setDefaultView = () => {
        const chips = document.querySelector('.search-hero__chips');
        const radioButtons = [...chips.querySelectorAll('input[type=radio]')];

        if (window.location.hash) {
            const element = document.querySelector(`div[data-name="${window.location.hash.substring(1)}"].profile-box`);
            const radio = document.querySelector(`.search-hero__chip-radio[value="${window.location.hash.substring(1)}"]`);

            if (element && radio) {
                element.classList.add('profile-box--active');
                radio.parentElement.classList.add('search-hero__chip--selected');
                radio.parentElement.classList.remove('search-hero__chip--inactive');
                this.pushPartialPageView(radio.parentElement.textContent, window.location.hash);
                return;
            }
        }
        const element = document.querySelector(`div[data-name="${radioButtons[0].value}"].profile-box`);
        const radio = document.querySelector(`.search-hero__chip-radio[value="${radioButtons[0].value}"]`);
        element.classList.add('profile-box--active');
        radio.parentElement.classList.add('search-hero__chip--selected');
        radio.parentElement.classList.remove('search-hero__chip--inactive');
        this.pushPartialPageView(radio.parentElement.textContent, `#${radioButtons[0].value}`);
    }

    initializeChips = () => {
        const chips = document.querySelector('.search-hero__chips');
        const radioButtons = [...chips.querySelectorAll('input[type=radio]')];
        const that = this;
        radioButtons.forEach((radioButton) => {
            radioButton.addEventListener(`click`, function (e) {
                radioButtons.forEach((r) => {
                    r.parentElement.classList.remove('search-hero__chip--selected');
                    r.parentElement.classList.add('search-hero__chip--inactive');
                    r.checked = false;
                });

                e.target.parentElement.classList.add('search-hero__chip--selected');
                e.target.parentElement.classList.remove('search-hero__chip--inactive');
                e.target.checked = true;

                const boxToShow = e.target.value;

                [...document.querySelectorAll('.profile-box')].forEach((box) => {
                    box.classList.remove('profile-box--active');
                    const currentBox = box.dataset.name;

                    if (boxToShow == currentBox) {
                        box.classList.add('profile-box--active');
                        history.pushState(null, null, `#${currentBox}`);
                        that.pushPartialPageView(e.target.parentElement.textContent, `#${currentBox}`);
                    }
                });
            });
        });
    }

    addLoadingDots = (form) => {
        const loadingContainer = document.createElement("div");
        loadingContainer.classList.add('profile-box__loading-dots-container');
        const loadingDots = document.createElement("div");
        loadingDots.classList.add("loading-dots");

        for (let i = 0; i < 4; i++) {
            loadingDots.appendChild(document.createElement("div"));
        }

        loadingContainer.appendChild(loadingDots)
        form.parentElement.appendChild(loadingContainer);
    }

    removeLoadingDots = (form) => {
        const loadingDots = form.parentElement.querySelector(".profile-box__loading-dots-container");
        loadingDots.remove();
    }

    addEventListeners = () => {
        //const contactPersonCreateBtn = document.querySelector('#createcontact-form button[type=submit]');
        //if (contactPersonCreateBtn) {
        //    contactPersonCreateBtn.addEventListener("click", this.handleContactPersonCreate.bind(this));
        //}

        const branschSelect = document.querySelector('#MemberInformation_Branch');
        const branschSubmitButton = document.querySelector('#bransch-select-submit-button');
        if (branschSelect && branschSubmitButton) {
            branschSelect.addEventListener('change', (e) => {
                branschSubmitButton.disabled = !e.target.value;
            });
        }

        const responsibleButton = document.querySelector('.profile__edit-button.profile__edit-button--responsible');
        const responsibleFormBox = document.querySelector('#responsible-box');

        if (responsibleButton && responsibleFormBox) {
            responsibleButton.addEventListener('click', () => {
                responsibleFormBox.classList.toggle('profile-box__inner-box--hidden');
                responsibleFormBox.classList.toggle('profile-box__inner-box--expanded');
            });
        }

        const editButtons = document.querySelectorAll('.contactlist-form td .contact_edit-button');
        const cancelButtons = document.querySelectorAll('.contactlist-form td .contact_cancel-button');
        const saveButtons = document.querySelectorAll('.contactlist-form td .contact_save-button');

        [editButtons, cancelButtons, saveButtons].forEach(buttons => {
            buttons.forEach(btn => {
                btn.addEventListener("click", this.handleEditButtonClick.bind(this));
            });
        });

        const certificateChooser = document.querySelector('select.profile__certificate-chooser');
        if (certificateChooser) {
            certificateChooser.addEventListener("change", () => {
                const selectedValue = certificateChooser.value;
                document.querySelectorAll('.profile__certificate').forEach(element => {
                    element.classList.toggle('profile__certificate--active', !selectedValue || element.dataset.certificateorgiid === selectedValue);
                });

                const downloadLink = document.querySelector('.profile__download-certificate-link');

                if (downloadLink) {
                    const url = new URL(downloadLink.href);
                    url.searchParams.delete('certificate');
                    url.searchParams.append('certificate', selectedValue);
                    downloadLink.href = url.toString();
                }

                const form = document.querySelector('.profile__mail-form');

                if (form) {
                    const url = new URL(form.action);
                    url.searchParams.delete('certificate');
                    url.searchParams.append('certificate', selectedValue);
                    form.action = url.toString();
                }
            });
        }

        const asyncForms = document.querySelectorAll("form.profile-box__form");
        asyncForms.forEach(form => {
            form.addEventListener("submit", this.handleFormSubmit.bind(this));
        });
        
        const subscriptionForm = document.querySelector("#subscription-form");
        if (subscriptionForm) {
            subscriptionForm.addEventListener("submit", e => {
                const dataLayer = window.dataLayer || [];
                dataLayer.push({
                    'event': 'subscriptions',
                    'selectedBranch': Analytics.getBranchName(),
                });
            });
        }

        const invoiceLinks = document.querySelectorAll(".profile-box__invoice-download");
        invoiceLinks.forEach(link => {
            link.addEventListener("click", this.handleInvoiceDownload.bind(this));
        });

        const removeContactBtns = document.querySelectorAll("button.profile-contacts__edit-action-button--remove");
        removeContactBtns.forEach(btn => {
            btn.addEventListener("click", this.handleContactRemove.bind(this));
        });

        [...document.querySelectorAll('.profile-contacts__action-button--edit')].forEach((element) => {
            element.addEventListener("click", this.handleEditContactPersonOnClick.bind(this));
        });

        [...document.querySelectorAll('.profile-box__form-close-button')].forEach((closeButton) => {
            closeButton.addEventListener("click", (e) => {
                e.preventDefault();
                const card = e.target.closest('.profile-box--active');
                card.classList.remove('profile-box--active');
                card.setAttribute('aria-hidden', 'false');
                const hiddenUpdatedElement = card.querySelector('.contact_is-updated');
                if (hiddenUpdatedElement) {
                    hiddenUpdatedElement.value = "False";
                }

                [...document.querySelectorAll('.profile-box__add-contact-person-button--expanded')].forEach((expandedCloseButton) => {
                    expandedCloseButton.classList.remove('profile-box__add-contact-person-button--expanded');
                })
            });
        });

        [...document.querySelectorAll('.profile-contacts__edit-action-button--close')].forEach((closeButton) => {
            closeButton.addEventListener("click", (e) => {
                e.preventDefault();
                const card = e.target.closest('.profile-contacts__card');
                card.classList.remove('profile-contacts__card--edit');
                card.classList.add('profile-contacts__card--preview');
            });
        });

        const newContactbtn = document.querySelector("#addcontact");
        if (newContactbtn) {
            newContactbtn.addEventListener("click", this.handleNewContactClick.bind(this));
        }

        const certificateEmailForm = document.querySelector('.profile__mail-form');
        if (certificateEmailForm) {
            certificateEmailForm.addEventListener('submit', this.handleCertificateEmailSubmit.bind(this));
        }

        const profileEditButtons = document.querySelectorAll(".profile__edit-button");
        if (profileEditButtons) {
            profileEditButtons.forEach(button => {
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const target = e.currentTarget;

                    const changeOnToggle = !!target.dataset.changeOnToggle && target.dataset.changeOnToggle.toLowerCase() === 'true';
                    if (changeOnToggle) {
                        const icon = target.querySelector('i');
                        const currentIcon = icon.className;
                        const textContainer = target.querySelector('span');
                        const currentText = textContainer.textContent;

                        icon.className = target.dataset.toggledIcon;
                        target.dataset.toggledIcon = currentIcon;
                        textContainer.textContent = target.dataset.toggledText;
                        target.dataset.toggledText = currentText;
                    }

                    const toggleTarget = !!target.dataset.toggleTarget && target.parentElement.querySelector(target.dataset.toggleTarget);
                    if (!toggleTarget)
                        return;

                    if (toggleTarget.matches("dialog")) {
                        toggleTarget.showModal();
                    }
                });
            });
        }

        [...document.querySelectorAll('[data-download-type]')].forEach((element) => {
            element.addEventListener('click', (e) => {
                this.handleCertificatePrintEvent(e.currentTarget);
            });
        });
    }

    handleContactPersonCreate(e) {
        e.preventDefault();
        const createContactForm = document.querySelector('#createcontact-form');
        if (createContactForm.checkValidity()) {
            e.target.disabled = true;
            createContactForm.submit();
        }
    }

    handleEditButtonClick(e) {
        e.preventDefault();
        const rowElem = e.target.closest("tr");
        this.toggleEditMode(rowElem);
    }

    handleFormSubmit(e) {
        e.preventDefault();
        const form = e.target;

        if (form.checkValidity()) {
            const submit = form.querySelector('button[type=submit]');
            submit.disabled = true;
            this.postForm(form);
        }
    }

    handleInvoiceDownload(e) {
        e.preventDefault();
        Analytics.downloadInvoice();
        window.open(e.target.href);
    }

    handleContactRemove(e) {
        e.preventDefault();
        const form = document.querySelector("#contactlist-form");
        const hiddenDeleteElement = e.currentTarget.closest('.profile-contacts__edit-card').querySelector('.contact_is-deleted');
        hiddenDeleteElement.value = "True";
        this.postForm(form);
    }

    handleEditContactPersonOnClick = (e) => {
        e.preventDefault();
        const card = e.currentTarget.closest('.profile-contacts__card');

        [...document.querySelectorAll('.profile-contacts__card.profile-contacts__card--edit')].forEach(item => {
            item.classList.remove('profile-contacts__card--edit');
            item.classList.add('profile-contacts__card--preview');
        });

        card.classList.remove('profile-contacts__card--preview');
        card.classList.add('profile-contacts__card--edit');

        const hiddenUpdatedElement = card.querySelector('.contact_is-updated');
        hiddenUpdatedElement.value = "True";
    }

    handleNewContactClick(e) {
        e.preventDefault();
        const button = document.querySelector("#addcontact");
        const contactFormProfileBox = document.querySelector('#contact-form-profile-box');
        const isClosed = !contactFormProfileBox.classList.contains('profile-box--active');

        if (isClosed) {
            contactFormProfileBox.classList.add('profile-box--active');
            contactFormProfileBox.setAttribute('aria-hidden', 'false');
            button.classList.add('profile-box__add-contact-person-button--expanded');
        }
        else {
            contactFormProfileBox.classList.remove('profile-box--active');
            contactFormProfileBox.setAttribute('aria-hidden', 'true');
            button.classList.remove('profile-box__add-contact-person-button--expanded');
        }
    }

    handleCertificateEmailSubmit(e) {
        e.preventDefault();
        const certificateEmailForm = e.target;
        const container = certificateEmailForm.parentElement;
        const clientWidth = container.clientWidth;
        const data = new FormData(certificateEmailForm);
        const email = data.get('emailAddress');

        if (!email) {
            return;
        }

        certificateEmailForm.classList.add('profile__mail-form--loading');

        const separator = certificateEmailForm.action.includes('?') ? '&' : '?';
        const fetchUrl = `${certificateEmailForm.action}${separator}emailAddress=${email}`;

        fetch(fetchUrl, {
            method: 'GET',
        })
            .then(response => {
                if (response.ok) {
                    const textElement = container.querySelector(".profile__mail-text");
                    const submitButton = container.querySelector("button");
                    const emailField = container.querySelector('input.profile__mail-input');

                    container.classList.add('profile__mail-button--success');
                    container.style.width = `${clientWidth}px`;
                    textElement.textContent = "Intyget har skickats";
                    submitButton.disabled = true;

                    setTimeout(() => {
                        container.classList.remove('profile__mail-button--success');
                        container.style.width = 'unset';
                        textElement.textContent = "Mejla intyg till";
                        submitButton.disabled = false;
                        emailField.value = '';
                    }, 3000)
                } else {
                    container.classList.add('profile__mail-button--error');
                }
            })
            .catch(error => {
                container.classList.add('profile__mail-button--error');
            })
            .finally(() => {
                certificateEmailForm.classList.remove('profile__mail-form--loading');
            });
    }

    toggleEditMode(rowElem) {
        const id = rowElem.getAttribute("id");
        const connectedRow = id.includes("_edit") ? document.getElementById(id.replace("_edit", "")) : document.getElementById(id + "_edit");
        rowElem.classList.add("hidden");
        connectedRow.classList.remove("hidden");
        const theEditRow = id.includes("_edit") ? rowElem : connectedRow;
        const updatedHidden = document.querySelector(`#${theEditRow.id} .contact_is-updated`);
        updatedHidden.value = id.includes("_edit") ? "False" : "True";
    }

    insertAfter(referenceNode, newNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }

    removeMessageBoxes() {
        const errorEl = document.querySelectorAll('.profile-box__message');
        errorEl.forEach(el => el.parentNode.removeChild(el));
    }

    serialize(form) {
        const values = {};

        for (const field of form.elements) {
            if (!field.name ||
                field.disabled ||
                field.type === 'file' ||
                field.type === 'reset' ||
                field.type === 'submit' ||
                field.type === 'button')
                continue;

            if (field.type === 'select-multiple' || field.type === 'select-one') {
                for (const option of field.options) {
                    if (option.selected) {
                        values[field.name] = option.value;
                    }
                }
            } else if (field.type === 'checkbox' || field.type === 'radio') {
                values[field.name] = field.checked ? field.value : null;
            } else {
                values[field.name] = field.value;
            }
        }

        return values;
    }

    // Hacky way to bind
    convertContactListToArrayOfContactPersons(obj) {
        const contactList = [];

        Object.keys(obj).forEach(key => {
            const match = key.match(/ContactPersonList\[(\d+)\]\.(\w+)/);
            if (match) {
                const index = parseInt(match[1], 10);
                const property = match[2];
    
                if (!contactList[index]) {
                    contactList[index] = {};
                }
    
                if (property === "IsUpdated" || property === "IsDeleted") {
                    contactList[index][property] = obj[key] === "True";
                } else {
                    contactList[index][property] = obj[key];
                }
            }
        });
    
        return contactList;
    }

    postForm(form) {
        form.classList.add('profile-box__form--loading');
        const isReloadForm = form.classList.contains('profile-box__form--reload');
        const submit = form.querySelector('button[type=submit]');

        if (submit) {
            submit.disabled = true;
        }

        this.removeMessageBoxes();
        this.addLoadingDots(form);
        let values = this.serialize(form);

        if (form.id === 'contactlist-form') {
            values = this.convertContactListToArrayOfContactPersons(values);
        }

        fetch(form.attributes['action'].value, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(values)
        })
            .then(response => response.json())
            .then(data => {
                if (!isReloadForm) {
                    submit.disabled = false;
                    const isError = data !== '';
                    if (isError) {
                        this.addErrorMessageBox(form, data === '' ? [] : data, true);
                    }
                    else {
                        this.showConfirmationInButton(form);
                    }
                }
            })
            .finally(() => {
                if (isReloadForm) {
                    window.location.reload();
                    return;
                }

                submit.disabled = false
                form.classList.remove('profile-box__form--loading');
                this.removeLoadingDots(form);
            });
    }

    showConfirmationInButton = (form) => {
        const submitButton = form.querySelector('button[type=submit].button-new--confirmation');
        submitButton.disabled = true;
        const previousText = submitButton.textContent;
        submitButton.style.width = `${submitButton.clientWidth}px`;
        submitButton.classList.add('button-new--active-confirmation');
        this.setTextInElement(submitButton, "Sparat");

        setTimeout(() => {
            submitButton.classList.remove('button-new--active-confirmation');
            this.setTextInElement(submitButton, previousText);
            submitButton.removeAttribute('style');
            submitButton.disabled = false;
        }, 3000)
    }

    setTextInElement = (element, text) => {
        element.childNodes.forEach((node) => {
            if (node.nodeType === Node.TEXT_NODE) {
                node.textContent = text;
            }
        });
    }

    addErrorMessageBox = (form, messages) => {
        const messageBox = document.createElement("div");
        const ul = document.createElement("ul");

        messages.forEach(message => {
            const li = document.createElement("li");
            li.textContent = message;
            ul.appendChild(li);
        });

        messageBox.appendChild(ul);
        messageBox.className = "profile-box__message profile-box__message--error";
        form.appendChild(messageBox);
    }

    getBranchName() {
        const branchBtn = document.querySelector('.branch__open');
        if (!branchBtn) return
        let branchName = branchBtn.innerText
        return branchName === 'VÄLJ BRANSCH' ? null : branchName.charAt(0).toUpperCase() + branchName.slice(1).toLowerCase()
    }

    handleCertificatePrintEvent = (target) => {
        const dataLayer = window.dataLayer || [];
        const downloadType = target.dataset.downloadType;

        if (!downloadType) {
            console.error('No download type found on element');
            return;
        }

        dataLayer.push({
            'event': 'certificatePrint',
            'isAuthenticated': String(window.authenticated).charAt(0).toUpperCase() + String(window.authenticated).slice(1).toLowerCase(),
            'selectedBranch': this.getBranchName(),
            'printType': downloadType
        });
    }
    
    pushPartialPageView(text, hash) {
        text = text.trim();
        hash = hash.trim();
        
        if (!text || !hash) {
            console.error('Missing text or hash');
            return;
        }
        const data = {
            'event': 'virtualPageview',
            'page': location.href.replace("#", ""),
            'pageTitle': `${document.title} - ${text}`,
            'contentType': window.pageType,
            'isAuthenticated': Analytics.getAuthenticated(),
            'selectedBranch': Analytics.getBranchName()
        };
        setTimeout(() => {
            const dataLayer = window.dataLayer || [];
            dataLayer.push(data);
        }, 100);
    }
}

document.addEventListener("DOMContentLoaded", () => new Profile());
